/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type TimeSlotCardTimeSlotFragment = { startsAt: TimeString, endsAt: TimeString };

export const TimeSlotCardTimeSlotFragmentDoc = gql`
    fragment TimeSlotCardTimeSlot on TimeSlot {
  startsAt
  endsAt
}
    `;